module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 84);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/input");

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/tooltip");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/utils/util");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/utils/schema");

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/select");

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-form-item",
      class: [
        {
          "el-form-item--feedback": _vm.elForm && _vm.elForm.statusIcon,
          "is-error": _vm.validateState === "error",
          "is-validating": _vm.validateState === "validating",
          "is-success": _vm.validateState === "success",
          "is-required": _vm.isRequired || _vm.required,
          "is-no-asterisk": _vm.elForm && _vm.elForm.hideRequiredAsterisk
        },
        _vm.sizeClass ? "el-form-item--" + _vm.sizeClass : ""
      ]
    },
    [
      _c(
        "label-wrap",
        {
          attrs: {
            "is-auto-width": _vm.labelStyle && _vm.labelStyle.width === "auto",
            "update-all": _vm.form.labelWidth === "auto"
          }
        },
        [
          _vm.label || _vm.$slots.label
            ? _c(
                "label",
                {
                  staticClass: "el-form-item__label",
                  style: _vm.labelStyle,
                  attrs: { for: _vm.labelFor }
                },
                [
                  _vm._t("label", [
                    _vm._v(_vm._s(_vm.label + _vm.form.labelSuffix))
                  ]),
                  _vm.tooltip
                    ? _c(
                        "el-tooltip",
                        {
                          staticClass: "label__tooltip",
                          attrs: { content: _vm.tooltip, placement: "top" }
                        },
                        [_c("i", { staticClass: "el-icon-question" })]
                      )
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ]
      ),
      _c(
        "div",
        { staticClass: "el-form-item__content", style: _vm.contentStyle },
        [
          _vm._t("default"),
          _c(
            "transition",
            { attrs: { name: "el-zoom-in-top" } },
            [
              _vm.validateState === "error" &&
              _vm.showMessage &&
              _vm.form.showMessage
                ? _vm._t(
                    "error",
                    [
                      _c(
                        "div",
                        {
                          staticClass: "el-form-item__error",
                          class: {
                            "el-form-item__error--inline":
                              typeof _vm.inlineMessage === "boolean"
                                ? _vm.inlineMessage
                                : (_vm.elForm && _vm.elForm.inlineMessage) ||
                                  false
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.validateMessage) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    { error: _vm.validateMessage }
                  )
                : _vm._e()
            ],
            2
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&

// EXTERNAL MODULE: external "async-validator"
var external_async_validator_ = __webpack_require__(43);
var external_async_validator_default = /*#__PURE__*/__webpack_require__.n(external_async_validator_);

// EXTERNAL MODULE: external "setaria-ui/lib/mixins/emitter"
var emitter_ = __webpack_require__(5);
var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

// EXTERNAL MODULE: external "setaria-ui/lib/utils/merge"
var merge_ = __webpack_require__(9);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);

// EXTERNAL MODULE: external "setaria-ui/lib/utils/util"
var util_ = __webpack_require__(2);

// EXTERNAL MODULE: external "setaria-ui/lib/tooltip"
var tooltip_ = __webpack_require__(19);
var tooltip_default = /*#__PURE__*/__webpack_require__.n(tooltip_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/label-wrap.vue?vue&type=script&lang=js&


/* harmony default export */ var label_wrapvue_type_script_lang_js_ = ({
  props: {
    isAutoWidth: Boolean,
    updateAll: Boolean
  },

  inject: ['elForm', 'elFormItem'],

  render: function render() {
    var h = arguments[0];

    var slots = this.$slots.default;
    if (!slots) return null;
    if (this.isAutoWidth) {
      var autoLabelWidth = this.elForm.autoLabelWidth;
      var style = {};
      if (autoLabelWidth && autoLabelWidth !== 'auto') {
        var marginLeft = parseInt(autoLabelWidth, 10) - this.computedWidth;
        if (marginLeft) {
          style.marginLeft = marginLeft + 'px';
        }
      }
      return h(
        'div',
        { 'class': 'el-form-item__label-wrap', style: style },
        [slots]
      );
    } else {
      return slots[0];
    }
  },


  methods: {
    getLabelWidth: function getLabelWidth() {
      if (this.$el && this.$el.firstElementChild) {
        var computedWidth = window.getComputedStyle(this.$el.firstElementChild).width;
        return Math.ceil(parseFloat(computedWidth));
      } else {
        return 0;
      }
    },
    updateLabelWidth: function updateLabelWidth() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'update';

      if (this.$slots.default && this.isAutoWidth && this.$el.firstElementChild) {
        if (action === 'update') {
          this.computedWidth = this.getLabelWidth();
        } else if (action === 'remove') {
          this.elForm.deregisterLabelWidth(this.computedWidth);
        }
      }
    }
  },

  watch: {
    computedWidth: function computedWidth(val, oldVal) {
      if (this.updateAll) {
        this.elForm.registerLabelWidth(val, oldVal);
        this.elFormItem.updateComputedLabelWidth(val);
      }
    }
  },

  data: function data() {
    return {
      computedWidth: 0
    };
  },
  mounted: function mounted() {
    this.updateLabelWidth('update');
  },
  updated: function updated() {
    this.updateLabelWidth('update');
  },
  beforeDestroy: function beforeDestroy() {
    this.updateLabelWidth('remove');
  }
});
// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_label_wrapvue_type_script_lang_js_ = (label_wrapvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue
var label_wrap_render, label_wrap_staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_label_wrapvue_type_script_lang_js_,
  label_wrap_render,
  label_wrap_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/form/src/label-wrap.vue"
/* harmony default export */ var label_wrap = (component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=script&lang=js&
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var form_itemvue_type_script_lang_js_ = ({
  name: 'ElFormItem',

  componentName: 'ElFormItem',

  mixins: [emitter_default.a],

  provide: function provide() {
    return {
      elFormItem: this
    };
  },


  inject: ['elForm'],

  components: {
    // use this component to calculate auto width1
    LabelWrap: label_wrap,
    ElTooltip: tooltip_default.a
  },

  props: {
    label: String,
    labelWidth: [String, Object],
    wrapperWidth: Object,
    prop: String,
    required: {
      type: Boolean,
      default: undefined
    },
    rules: [Object, Array],
    error: String,
    validateStatus: String,
    for: String,
    inlineMessage: {
      type: [String, Boolean],
      default: ''
    },
    showMessage: {
      type: Boolean,
      default: true
    },
    size: String,
    tooltip: String
  },
  watch: {
    error: {
      immediate: true,
      handler: function handler(value) {
        this.validateMessage = value;
        this.validateState = value ? 'error' : '';
      }
    },
    validateStatus: function validateStatus(value) {
      this.validateState = value;
    }
  },
  computed: {
    labelFor: function labelFor() {
      return this.for || this.prop;
    },
    labelStyle: function labelStyle() {
      var ret = {};
      if (this.form.labelPosition === 'top') return ret;
      var labelWidth = this.labelWidth || this.form.labelWidth;
      if (labelWidth) {
        ret.width = labelWidth;
      }
      return ret;
    },
    contentStyle: function contentStyle() {
      var ret = {};
      var label = this.label;
      if (this.form.labelPosition === 'top' || this.form.inline) return ret;
      if (!label && !this.labelWidth && this.isNested) return ret;
      var labelWidth = this.labelWidth || this.form.labelWidth;
      if (labelWidth === 'auto') {
        if (this.labelWidth === 'auto') {
          ret.marginLeft = this.computedLabelWidth;
        } else if (this.form.labelWidth === 'auto') {
          ret.marginLeft = this.elForm.autoLabelWidth;
        }
      } else {
        ret.marginLeft = labelWidth;
      }
      return ret;
    },
    form: function form() {
      var parent = this.$parent;
      var parentName = parent.$options.componentName;
      while (parentName !== 'ElForm') {
        if (parentName === 'ElFormItem') {
          this.isNested = true;
        }
        parent = parent.$parent;
        parentName = parent.$options.componentName;
      }
      return parent;
    },
    fieldValue: function fieldValue() {
      var model = this.form.model;
      if (!model || !this.prop) {
        return;
      }

      var path = this.prop;
      if (path.indexOf(':') !== -1) {
        path = path.replace(/:/, '.');
      }

      return Object(util_["getPropByPath"])(model, path, true).v;
    },
    isRequired: function isRequired() {
      var rules = this.getRules();
      var isRequired = false;

      if (rules && rules.length) {
        rules.every(function (rule) {
          if (rule.required) {
            isRequired = true;
            return false;
          }
          return true;
        });
      }
      return isRequired;
    },
    _formSize: function _formSize() {
      return this.elForm.size;
    },
    elFormItemSize: function elFormItemSize() {
      return this.size || this._formSize;
    },
    sizeClass: function sizeClass() {
      return this.elFormItemSize || (this.$ELEMENT || {}).size;
    },
    responsiveMode: function responsiveMode() {
      return this.labelWidth && _typeof(this.labelWidth) === 'object';
    }
  },
  data: function data() {
    return {
      validateState: '',
      validateMessage: '',
      validateDisabled: false,
      validator: {},
      isNested: false,
      computedLabelWidth: ''
    };
  },

  methods: {
    validate: function validate(trigger) {
      var _this = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : util_["noop"];

      this.validateDisabled = false;
      var rules = this.getFilteredRule(trigger);
      if ((!rules || rules.length === 0) && this.required === undefined) {
        callback();
        return true;
      }

      this.validateState = 'validating';

      var descriptor = {};
      if (rules && rules.length > 0) {
        rules.forEach(function (rule) {
          delete rule.trigger;
        });
      }
      descriptor[this.prop] = rules;

      var validator = new external_async_validator_default.a(descriptor);
      var model = {};

      model[this.prop] = this.fieldValue;

      validator.validate(model, { firstFields: true }, function (errors, invalidFields) {
        _this.validateState = !errors ? 'success' : 'error';
        _this.validateMessage = errors ? errors[0].message : '';

        callback(_this.validateMessage, invalidFields);
        _this.elForm && _this.elForm.$emit('validate', _this.prop, !errors, _this.validateMessage || null);
      });
    },
    clearValidate: function clearValidate() {
      this.validateState = '';
      this.validateMessage = '';
      this.validateDisabled = false;
    },
    resetField: function resetField() {
      var _this2 = this;

      this.validateState = '';
      this.validateMessage = '';

      var model = this.form.model;
      var value = this.fieldValue;
      var path = this.prop;
      if (path.indexOf(':') !== -1) {
        path = path.replace(/:/, '.');
      }

      var prop = Object(util_["getPropByPath"])(model, path, true);

      this.validateDisabled = true;
      if (Array.isArray(value)) {
        prop.o[prop.k] = [].concat(this.initialValue);
      } else {
        prop.o[prop.k] = this.initialValue;
      }

      // reset validateDisabled after onFieldChange triggered
      this.$nextTick(function () {
        _this2.validateDisabled = false;
      });

      this.broadcast('ElTimeSelect', 'fieldReset', this.initialValue);
    },
    getRules: function getRules() {
      var formRules = this.form.rules;
      var selfRules = this.rules;
      var requiredRule = this.required !== undefined ? { required: !!this.required } : [];

      var prop = Object(util_["getPropByPath"])(formRules, this.prop || '');
      formRules = formRules ? prop.o[this.prop || ''] || prop.v : [];

      return [].concat(selfRules || formRules || []).concat(requiredRule);
    },
    getFilteredRule: function getFilteredRule(trigger) {
      var rules = this.getRules();

      return rules.filter(function (rule) {
        if (!rule.trigger || trigger === '') return true;
        if (Array.isArray(rule.trigger)) {
          return rule.trigger.indexOf(trigger) > -1;
        } else {
          return rule.trigger === trigger;
        }
      }).map(function (rule) {
        return merge_default()({}, rule);
      });
    },
    onFieldBlur: function onFieldBlur() {
      this.validate('blur');
    },
    onFieldChange: function onFieldChange() {
      if (this.validateDisabled) {
        this.validateDisabled = false;
        return;
      }

      this.validate('change');
    },
    updateComputedLabelWidth: function updateComputedLabelWidth(width) {
      this.computedLabelWidth = width ? width + 'px' : '';
    },
    addValidateEvents: function addValidateEvents() {
      var rules = this.getRules();

      if (rules.length || this.required !== undefined) {
        this.$on('el.form.blur', this.onFieldBlur);
        this.$on('el.form.change', this.onFieldChange);
      }
    },
    removeValidateEvents: function removeValidateEvents() {
      this.$off();
    }
  },
  mounted: function mounted() {
    if (this.prop) {
      this.dispatch('ElForm', 'el.form.addField', [this]);

      var initialValue = this.fieldValue;
      if (Array.isArray(initialValue)) {
        initialValue = [].concat(initialValue);
      }
      Object.defineProperty(this, 'initialValue', {
        value: initialValue
      });

      this.addValidateEvents();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatch('ElForm', 'el.form.removeField', [this]);
  }
});
// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_form_itemvue_type_script_lang_js_ = (form_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/form/src/form-item.vue





/* normalize component */

var form_item_component = Object(componentNormalizer["a" /* default */])(
  src_form_itemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var form_item_api; }
form_item_component.options.__file = "packages/form/src/form-item.vue"
/* harmony default export */ var form_item = __webpack_exports__["a"] = (form_item_component.exports);

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "el-form",
      class: [
        _vm.labelPosition ? "el-form--label-" + _vm.labelPosition : "",
        { "el-form--inline": _vm.inline },
        _vm.labelSuffix !== "" ? "el-form-has-label-suffix" : ""
      ],
      on: {
        keyup: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          $event.preventDefault()
          _vm.handleSubmit($event)
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&

// EXTERNAL MODULE: external "setaria-ui/lib/utils/merge"
var merge_ = __webpack_require__(9);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var formvue_type_script_lang_js_ = ({
  name: 'ElForm',

  componentName: 'ElForm',

  provide: function provide() {
    return {
      elForm: this
    };
  },


  props: {
    model: Object,
    rules: Object,
    labelPosition: String,
    labelWidth: {
      type: String,
      default: 'auto'
    },
    labelSuffix: {
      type: String,
      default: ''
    },
    inline: Boolean,
    inlineMessage: Boolean,
    statusIcon: Boolean,
    showMessage: {
      type: Boolean,
      default: true
    },
    size: String,
    disabled: Boolean,
    validateOnRuleChange: {
      type: Boolean,
      default: true
    },
    hideRequiredAsterisk: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    rules: function rules() {
      // remove then add event listeners on form-item after form rules change
      this.fields.forEach(function (field) {
        field.removeValidateEvents();
        field.addValidateEvents();
      });

      if (this.validateOnRuleChange) {
        this.validate(function () {});
      }
    }
  },
  computed: {
    autoLabelWidth: function autoLabelWidth() {
      if (!this.potentialLabelWidthArr.length) return 0;
      var max = Math.max.apply(Math, this.potentialLabelWidthArr);
      return max ? max + 'px' : '';
    }
  },
  data: function data() {
    return {
      fields: [],
      potentialLabelWidthArr: [] // use this array to calculate auto width
    };
  },
  created: function created() {
    var _this = this;

    this.$on('el.form.addField', function (field) {
      if (field) {
        _this.fields.push(field);
      }
    });
    /* istanbul ignore next */
    this.$on('el.form.removeField', function (field) {
      if (field.prop) {
        _this.fields.splice(_this.fields.indexOf(field), 1);
      }
    });
  },

  methods: {
    resetFields: function resetFields() {
      if (!this.model) {
        console.warn('[Element Warn][Form]model is required for resetFields to work.');
        return;
      }
      this.fields.forEach(function (field) {
        field.resetField();
      });
    },
    clearValidate: function clearValidate() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var fields = props.length ? typeof props === 'string' ? this.fields.filter(function (field) {
        return props === field.prop;
      }) : this.fields.filter(function (field) {
        return props.indexOf(field.prop) > -1;
      }) : this.fields;
      fields.forEach(function (field) {
        field.clearValidate();
      });
    },
    validate: function validate(callback) {
      var _this2 = this;

      if (!this.model) {
        console.warn('[Element Warn][Form]model is required for validate to work!');
        return;
      }
      var promise = void 0;
      // if no callback, return promise
      if (typeof callback !== 'function' && window.Promise) {
        promise = new window.Promise(function (resolve, reject) {
          callback = function callback(valid) {
            valid ? resolve(valid) : reject(valid);
          };
        });
      }

      var valid = true;
      var count = 0;
      // 如果需要验证的fields为空，调用验证时立刻返回callback
      if (this.fields.length === 0 && callback) {
        callback(true);
      }
      var invalidFields = {};
      this.fields.forEach(function (field) {
        field.validate('', function (message, field) {
          if (message) {
            valid = false;
          }
          invalidFields = merge_default()({}, invalidFields, field);
          if (typeof callback === 'function' && ++count === _this2.fields.length) {
            callback(valid, invalidFields);
          }
        });
      });

      if (promise) {
        return promise;
      }
    },
    validateField: function validateField(props, cb) {
      props = [].concat(props);
      var fields = this.fields.filter(function (field) {
        return props.indexOf(field.prop) !== -1;
      });
      if (!fields.length) {
        console.warn('[Element Warn]please pass correct props!');
        return;
      }

      fields.forEach(function (field) {
        field.validate('', cb);
      });
    },
    handleSubmit: function handleSubmit(event) {
      // 触发submit事件
      this.$emit('submit');
    },
    getLabelWidthIndex: function getLabelWidthIndex(width) {
      var index = this.potentialLabelWidthArr.indexOf(width);
      // it's impossible
      if (index === -1) {
        console.error('[ElementForm]unpected width ', width);
      }
      return index;
    },
    registerLabelWidth: function registerLabelWidth(val, oldVal) {
      if (val && oldVal) {
        var index = this.getLabelWidthIndex(oldVal);
        this.potentialLabelWidthArr.splice(index, 1, val);
      } else if (val) {
        this.potentialLabelWidthArr.push(val);
      }
    },
    deregisterLabelWidth: function deregisterLabelWidth(val) {
      var index = this.getLabelWidthIndex(val);
      this.potentialLabelWidthArr.splice(index, 1);
    }
  }
});
// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_formvue_type_script_lang_js_ = (formvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/form/src/form.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_formvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/form/src/form.vue"
/* harmony default export */ var src_form = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var setaria_ui_packages_form_src_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33);
/* harmony import */ var setaria_ui_packages_form_src_form_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32);
/* harmony import */ var setaria_ui_packages_select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27);
/* harmony import */ var setaria_ui_packages_select__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(setaria_ui_packages_select__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var setaria_ui_packages_input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12);
/* harmony import */ var setaria_ui_packages_input__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(setaria_ui_packages_input__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var setaria_ui_src_utils_merge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9);
/* harmony import */ var setaria_ui_src_utils_merge__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(setaria_ui_src_utils_merge__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var setaria_ui_src_utils_schema__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20);
/* harmony import */ var setaria_ui_src_utils_schema__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(setaria_ui_src_utils_schema__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var setaria_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2);
/* harmony import */ var setaria_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(setaria_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_7__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var CLASSNAME = 'className';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ElJsonForm',
  componentName: 'ElJsonForm',
  props: {
    model: Object,
    // 表单提交是否重载页面
    isPrevent: {
      type: Boolean,
      default: true
    },
    schema: {
      type: Object,
      required: true
    },
    uiSchema: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    columns: {
      type: Number,
      default: 4
    },
    componentPrefix: {
      type: String,
      default: 'el'
    },
    columnMaxLabelLength: Number,
    rules: Object
  },
  data: function data() {
    return {};
  },

  computed: {
    innerRules: function innerRules() {
      var _rules = this.rules,
          rules = _rules === undefined ? {} : _rules;

      var ret = Object(setaria_ui_src_utils_schema__WEBPACK_IMPORTED_MODULE_6__["createFormRulesBySchema"])(this.schema, this.uiSchema);
      return setaria_ui_src_utils_merge__WEBPACK_IMPORTED_MODULE_5___default()({}, ret, rules);
    },
    fields: function fields() {
      if (this.$refs.form) {
        return this.$refs.form.fields;
      }
      return [];
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    handleSubmit: function handleSubmit() {
      this.$emit('submit');
    },
    validate: function validate(callback) {
      return this.$refs.form.validate(callback);
    },
    validateField: function validateField(props, cb) {
      return this.$refs.form.validateField(props, cb);
    },
    resetFields: function resetFields() {
      this.$refs.form.resetFields();
    },
    getFormLabelSlot: function getFormLabelSlot(h, property, columnMaxLabelLength, colSpan) {
      var componentPrefix = this.componentPrefix;

      var span = typeof colSpan === 'number' ? colSpan : 1;
      var ret = null;
      var textSpan = null;
      var tooltip = null;
      var slotChildren = [];
      if (typeof columnMaxLabelLength === 'number') {
        var ellipsis = h(componentPrefix + '-ellipsis', {
          props: {
            tooltip: true,
            'full-width-recognition': true,
            length: columnMaxLabelLength * span
          }
        }, [property.title]);
        textSpan = h('div', {
          'class': ['label-inner__ellipsis']
        }, [ellipsis]);
      }
      if (!Object(setaria_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_7__["isEmpty"])(property.description)) {
        if (textSpan === null) {
          textSpan = h('span', {
            domProps: {
              innerHTML: property.title
            }
          });
        }
        var icon = h(componentPrefix + '-icon', {
          props: {
            name: 'warning-outline',
            tooltip: false
          },
          style: {
            cursor: 'auto'
          }
        });
        tooltip = h(componentPrefix + '-tooltip', {
          props: {
            placement: 'top'
          },
          style: {
            marginLeft: '5px'
          }
        }, [icon, h('span', {
          domProps: {
            innerHTML: property.description
          },
          slot: 'content',
          style: {
            display: 'inline-block',
            maxWidth: '400px'
          }
        })]);
      }
      if (textSpan) {
        slotChildren.push(textSpan);
      }
      if (tooltip) {
        slotChildren.push(tooltip);
      }
      if (slotChildren.length > 0) {
        ret = function ret(props) {
          return h('div', {
            class: {
              'el-json-form__label-inner': true
            }
          }, slotChildren);
        };
      }
      return ret;
    }
  },
  render: function render(h) {
    var _this = this;

    // model属性必须设置，否则表单内组件无法正确进行相应
    if (Object(setaria_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_7__["isEmpty"])(this.model)) {
      console.warn('表单组件的model属性需要设置非空值。');
      return null;
    }
    var self = this;
    var componentPrefix = self.componentPrefix,
        $scopedSlots = self.$scopedSlots;

    var formItemArray = [];
    var formEvents = {
      on: {}
    };
    formEvents.on.submit = function () {
      _this.handleSubmit();
    };
    var model = this.model;
    if (this.schema && this.schema.properties) {
      Object.keys(this.schema.properties).forEach(function (key) {
        var ui = _this.uiSchema[key] || {};
        var formItem = null;
        var property = self.schema.properties[key];
        // title不为空的场合，基于schema进行渲染
        if (!Object(setaria_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_7__["isEmpty"])(property.title)) {
          var formItemChildren = [];
          if ($scopedSlots[key] === undefined) {
            var className = ui[CLASSNAME] || '';
            var component = Object(setaria_ui_src_utils_schema__WEBPACK_IMPORTED_MODULE_6__["createElementByProperty"])(key, property, ui, model, _this.$emit);
            if (component) {
              component.componentProps.class = 'el-json-form__component ' + className;
              var componentTagName = component.componentTagName,
                  componentProps = component.componentProps,
                  componentChildrenOptions = component.componentChildrenOptions;

              var componentChildren = [];
              componentChildrenOptions.forEach(function (item) {
                if (componentTagName === 'el-select') {
                  componentChildren.push(h('el-option', {
                    props: {
                      label: item.label,
                      value: item.value,
                      disabled: item.disabled
                    }
                  }));
                } else if (componentTagName === 'el-radio-group') {
                  componentChildren.push(h('el-radio', {
                    props: {
                      label: item.value
                    }
                  }, [item.label]));
                } else if (componentTagName === 'el-checkbox-group') {
                  componentChildren.push(h('el-checkbox', {
                    props: {
                      label: item.value
                    }
                  }, [item.label]));
                }
              });
              formItemChildren.push(h(componentTagName, componentProps, componentChildren));
            }
          } else {
            var childrenCustomRender = $scopedSlots[key]({ data: model });
            formItemChildren.push(childrenCustomRender);
          }
          var labelSlot = self.getFormLabelSlot(h, property, self.columnMaxLabelLength, colSpan);
          var colSpan = ui[setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_0__[/* JSON_FORM_UI */ "c"].UI_COLSPAN];
          formItem = h(componentPrefix + '-form-item', {
            'class': ['el-form-item-' + key, 'el-json-form-item'],
            props: {
              label: property.title,
              prop: key
            },
            scopedSlots: {
              label: labelSlot
            }
          }, [formItemChildren]);
        } else if (typeof ui[setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_0__[/* JSON_FORM_UI */ "c"].UI_RENDER] === 'function') {
          formItem = ui[setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_0__[/* JSON_FORM_UI */ "c"].UI_RENDER](h, { data: model });
        }
        if (!Object(setaria_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_7__["isEmpty"])(formItem)) {
          formItemArray.push({
            id: key,
            component: formItem
          });
        }
      });
    }
    var $attrs = this.$attrs;

    var formProps = _extends({}, $attrs, {
      model: model,
      rules: self.innerRules,
      isPrevent: self.isPrevent
    });
    var formComponents = formItemArray;
    // inline模式的场合不使用自适应
    if (this.$attrs.inline !== true) {
      // 自适应设置
      var rowArray = [];
      var colArray = [];
      // let totalSpanCount = 0;
      for (var index = 0; index < formItemArray.length; index += 1) {
        var formItem = formItemArray[index];
        var itemUISchema = this.uiSchema[formItem.id] || {};
        var uiColspan = itemUISchema[setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_0__[/* JSON_FORM_UI */ "c"].UI_COLSPAN];
        uiColspan = uiColspan > self.columns ? self.columns : uiColspan;
        var spanProp = null;
        var span = typeof uiColspan === 'number' ? 24 / self.columns * uiColspan : 24 / self.columns;
        // 考虑columns属性为5的场合
        if (self.columns === 5) {
          switch (uiColspan) {
            case 1:
              spanProp = '4-8';
              break;
            case 2:
              spanProp = '9-6';
              break;
            case 3:
              spanProp = '14-4';
              break;
            case 4:
              spanProp = '19-2';
              break;
            case 5:
              spanProp = '24';
              break;
            default:
              spanProp = '4-8';
          }
        } else {
          spanProp = span;
        }
        var isDisplay = itemUISchema[setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_0__[/* JSON_FORM_UI */ "c"].UI_HIDDEN];
        if (typeof itemUISchema[setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_0__[/* JSON_FORM_UI */ "c"].UI_HIDDEN] === 'function') {
          isDisplay = itemUISchema[setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_0__[/* JSON_FORM_UI */ "c"].UI_HIDDEN](model);
        }
        var column = h(componentPrefix + '-col', {
          props: {
            span: spanProp,
            xs: 24
          },
          style: {
            display: isDisplay ? 'none' : ''
          }
        }, [formItem.component]);
        colArray.push(column);
      }
      if (this.$slots.formItems) {
        colArray.push(this.$slots.formItems);
      }
      var labelWidth = self.$attrs['label-width'];
      var gutter = labelWidth === undefined || labelWidth === null ? 10 : 20;
      var row = h(componentPrefix + '-row', {
        props: {
          gutter: gutter
        }
      }, [].concat(colArray));
      rowArray.push(row);
      formComponents = rowArray;
    } else {
      formComponents = formItemArray.map(function (item) {
        return item.component;
      });
    }
    return h(componentPrefix + '-form', {
      'class': 'el-json-form',
      props: formProps,
      on: formEvents.on,
      ref: 'form'
    }, [].concat(formComponents, [self.$slots.default, self.$slots.button]));
  },

  components: {
    ElForm: setaria_ui_packages_form_src_form__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
    ElFormItem: setaria_ui_packages_form_src_form_item__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"],
    ElSelect: setaria_ui_packages_select__WEBPACK_IMPORTED_MODULE_3___default.a,
    ElInput: setaria_ui_packages_input__WEBPACK_IMPORTED_MODULE_4___default.a
  }
});

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

module.exports = require("async-validator");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/mixins/emitter");

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return JSON_FORM_UI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COLUMN_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDIT_TYPE; });
var JSON_FORM_UI = {
  UI_WIDGET: 'ui:widget',
  UI_OPTIONS: 'ui:options',
  UI_DISABLED: 'ui:disabled',
  UI_HIDDEN: 'ui:hidden',
  UI_FORMAT: 'ui:format',
  UI_ON: 'ui:on',
  UI_NATIVE_ON: 'ui:nativeOn',
  UI_PARENT_COLUMN_ID: 'ui:parentColumnId',
  UI_RULES: 'ui:rules',
  UI_PLACEHOLDER: 'ui:placeholder',
  UI_COLSPAN: 'ui:colspan',
  UI_RULE: 'ui:rules',
  UI_RENDER: 'ui:render'
};

var COLUMN_TYPE = {
  INDEX: 'index'
};

var EDIT_TYPE = {
  ADD: 'add',
  DELETE: 'delete',
  MODIFY: 'modify'
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _src_json_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37);


/* istanbul ignore next */
_src_json_form__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].install = function install(Vue) {
  Vue.component(_src_json_form__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].name, _src_json_form__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
};

/* harmony default export */ __webpack_exports__["default"] = (_src_json_form__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/utils/merge");

/***/ })

/******/ });